import React, { useContext, useEffect, useState } from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../Contexts/ThemeContext";
import SearchedProducts from "../../../Components/SearchedProducts/SearchedProducts";
import Accessories from "../../../Components/NavCategories/Accessories";
import Makeup from "../../../Components/NavCategories/Makeup";
import Skincare from "../../../Components/NavCategories/Skincare";
import Haircare from "../../../Components/NavCategories/Haircare";
import PersonalCare from "../../../Components/NavCategories/PersonalCare";

const Navbar = ({ popCart, handlePopCart }) => {
  const [focus, setFocus] = useState(false);
  const { searchText, setSearchText } = useContext(ThemeContext);
  const otpUser = JSON.parse(localStorage.getItem("user"));
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [searchedProductCount, setSearchedProductCount] = useState(0);
  const navigation = useNavigate();
  let highPriorityProducts = [];

  const [showBackIcon, setShowBackIcon] = useState(false);

  const showIcon = () => {
    setShowBackIcon(true);
  };

  useEffect(() => {
    if (searchText.length > 2) {
      fetch(
        `https://musfiq-trading-server.vercel.app/searchProduct/${searchText}/0`
      )
        .then((res) => res.json())
        .then((data) => setSearchedProducts(data));
    }
  }, [searchText.length]);

  useEffect(() => {
    fetch(
      `https://musfiq-trading-server.vercel.app/searchedProductCount?searchText=${searchText}`
    )
      .then((res) => res.json())
      .then((data) => {
        const count = data.count;
        setSearchedProductCount(count);
      });
  }, [searchText]);

  return (
    <div className="w-full hidden py-4 lg:block z-[10000] sticky top-0 bg-white">
      <div className="navbar px-0 lg:px-10 flex justify-between">
        {/*.................. logo ...................... */}
        <div className="cursor-pointer mr-auto">
          <Link to="/">
            <p className="text-2xl font-bold bg-gradient-to-r from-[#1C5E99] to-[#1DBFF8] bg-clip-text text-transparent">
              MUSFIQ TRADING
            </p>
          </Link>
        </div>
        <div
          className={`nav-menu relative hidden lg:flex transition-all ease-in-out duration-300 text-center min-h-[65px] text-white`}
        >
          {/*------------------------------------- All Navigation Category  ------------------------------------*/}

          <div className="all-menu">
            <Makeup showIcon={showIcon} />
            <Skincare showIcon={showIcon} />
            <Haircare showIcon={showIcon} />
            <PersonalCare showIcon={showIcon} />
            {/* <Accessories /> */}

            <Link
              to="/wholesale"
              className={`mr-10 block font-bold text-secondary hover:text-accent`}
            >
              WHOLESALE
            </Link>
          </div>
        </div>
        {/*.......... search bar............. */}
        <div className="form-control text-black 2xl:w-[500px] lg:w-[400px] relative">
          <form
            className="input-group"
            onSubmit={(e) => {
              e.preventDefault();
              navigation(`/search/${searchText}`);
              setFocus(false);
            }}
          >
            <input
              type="text"
              className="border border-r-0 border-[#cccccc] w-[100%] px-4"
              placeholder="Search for products"
              onFocus={() => setFocus(true)}
              onBlur={() => {
                setTimeout(() => setFocus(false), 200);
              }}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <button
              type="submit"
              className="btn btn-rounded bg-primary border border-l-0 border-[#cccccc]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 hover:text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </button>
          </form>

          {/*......... Search result............ */}
          <div>
            <SearchedProducts
              highPriorityProducts={highPriorityProducts}
              searchedProducts={searchedProducts}
              focus={focus}
              searchedProductCount={searchedProductCount}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
